import type { CoverageAreaInput, CoveragePartyInput } from "@/lib/coverage/coverageLookup";
import { circleRing, ringsFromGeoJson } from "@/lib/coverage/pointInArea";

export type CoverageFeature = {
  type: "Feature";
  properties: { partyId: string; tier: string; color: string; fillOpacity: number };
  geometry: { type: "Polygon"; coordinates: number[][][] };
};

export function territoryFeatures(
  parties: CoveragePartyInput[],
  areas: CoverageAreaInput[],
): { type: "FeatureCollection"; features: CoverageFeature[] } {
  const byId = new Map(parties.map((party) => [party.id, party]));
  const features: CoverageFeature[] = [];
  for (const area of areas) {
    const party = byId.get(area.partyId);
    if (!party?.active) continue;
    const rings = area.kind === "circle" ? circleRings(area) : ringsFromGeoJson(area.geojson);
    if (!rings) continue;
    features.push({
      type: "Feature",
      properties: {
        partyId: party.id,
        tier: area.tier,
        color: party.color,
        fillOpacity: area.tier === "preferred" ? 0.45 : 0.18,
      },
      geometry: {
        type: "Polygon",
        coordinates: rings.map((ring) => ring.map((point) => [point.lng, point.lat])),
      },
    });
  }
  return { type: "FeatureCollection", features };
}

function circleRings(area: CoverageAreaInput) {
  if (area.centerLat == null || area.centerLng == null || area.radiusKm == null || area.radiusKm <= 0) {
    return null;
  }
  return [circleRing({ lat: area.centerLat, lng: area.centerLng }, area.radiusKm)];
}
